import { size, __spreadValues } from './chunk-JJ6VZ5V7.mjs';
import * as React from 'react';
import styled, { color } from '@xstyled/styled-components';

var SvgComponent = (props) => /* @__PURE__ */ React.createElement(
  "svg",
  __spreadValues({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24px",
    height: "24px",
    fill: "none",
    "aria-hidden": "true",
    viewBox: "0 0 24 24"
  }, props),
  /* @__PURE__ */ React.createElement(
    "path",
    {
      fill: "currentColor",
      d: "m15.586 10.586-3.172-3.172C11.154 6.154 9 7.047 9 8.828v6.344c0 1.781 2.154 2.674 3.414 1.414l3.172-3.172a2 2 0 0 0 0-2.828"
    }
  )
);
var SvgArrowRightFilled = styled(SvgComponent)`
  ${size}
  ${color}
`;
var ArrowRightFilled_default = SvgArrowRightFilled;

export { ArrowRightFilled_default as default };
